import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function TwitterFill(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    d: "M21.594 5.244c.19-.41-.271-.749-.673-.539a8.41 8.41 0 01-1.74.682c-1.454-1.69-4.09-1.868-5.727-.356-1 .8-1.454 1.867-1.454 3.023v.89a9.773 9.773 0 01-7.648-3.34c-.252-.287-.711-.23-.826.133-.668 2.112-1.775 7.89 4.838 10.765a10.903 10.903 0 01-4.23 1.65c-.522.085-.68.83-.183 1.013 7.724 2.84 16.14-1.617 16.14-11.041v-.781a7.24 7.24 0 001.503-2.099z"
  }));
}

export default TwitterFill;